import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { CategoryCards } from '../components/CategoryCards';
import { dataModel } from '../components/dataModel';
import { getCategoryCardsForMA } from '../components/Helpers';

const CategoryCardsComposable = ({ enableProContentFilteringForB2B = false }) => {
    const { customContext, customer } = useContext(ExperienceContext);
    const { variables } = customContext || {};

    const keyword = variables?.keyword || '';
    const storeId = variables?.storeId || '';
    const navParam = variables?.navParam || '';

    const defaultOptions = {
        variables,
        ssr: true,
        skip: !keyword && !navParam,
    };

    const result = useDataModel('searchModel', defaultOptions);
    const { data, loading, error } = result || {};

    const isB2BCustomer = customer?.type === 'b2b';
    const effectiveData = enableProContentFilteringForB2B
        ? getCategoryCardsForMA(data, isB2BCustomer)
        : data;

    return (
        <CategoryCards
            data={effectiveData}
            loading={loading}
            error={error}
            storeId={storeId}
            keyword={keyword}
            navParam={navParam}
            ssr={true}
        />
    );
};

CategoryCardsComposable.displayName = 'CategoryCardsComposable';
CategoryCardsComposable.dataModel = dataModel;

export { CategoryCardsComposable };